import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import CategoryForm from '../form/CategoryForm';
import { CategoryValues } from '../model/categoryModel';
import { ROUTES } from '../../../core/router/routes';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings/SnackbarSettings';
import * as Selectors from '../redux/categorySelectors';
import * as Actions from '../redux/categoryActions';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';
import * as CommonSelectors from '../../../shared/redux/commonSelectors';
import { objectHelper } from '../../../shared/utils/objectHelper';

const initialValues: CategoryValues = {
  name: '',
  parent: '',
  image: '',
  categoryOne: {
    value: '',
    key: '',
  },
  categoryTwo: {
    value: '',
    key: '',
  },
};

const breadcrumbs = [
  {
    label: 'category.add',
    to: null,
  },
];

const CategoryAdd: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const apiRequestState = useSelector(Selectors.apiCategoryRequestState);
  const apiRequestError = useSelector(Selectors.apiCategoryRequestError);
  const rootCategory = useSelector(CommonSelectors.rootCategory);
  const { show, hide } = useMainProgressContext();

  useEffect(() => {
    hide();
  }, []);

  return (
    <>
      <SnackbarSettings
        successMessage="category.snackbar.add_success"
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiCategoryRequestState}
        onSuccess={() => {
          history.push(ROUTES.CATEGORY.LIST);
        }}
      />
      <CategoryForm
        parentId={rootCategory ? (rootCategory.value as unknown as number) : undefined}
        breadcrumbs={breadcrumbs}
        title="category.add"
        initialValues={initialValues}
        onSubmit={(values: CategoryValues) => {
          show();
          dispatch(
            Actions.addCategory(
              objectHelper.removeByKeys<CategoryValues>(['categoryOne', 'categoryTwo'], {
                ...values,
                parent: values.categoryTwo.key ? values.categoryTwo.key : values.categoryOne.key,
              }),
            ),
          );
        }}
      />
    </>
  );
};

export default CategoryAdd;
